import { render, staticRenderFns } from "./container-list.vue?vue&type=template&id=a64af912"
import script from "./container-list.vue?vue&type=script&lang=js"
export * from "./container-list.vue?vue&type=script&lang=js"
import style0 from "./container-list.vue?vue&type=style&index=0&id=a64af912&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports